import * as Sentry from '@sentry/react';
import { Toaster } from 'react-hot-toast';
import { QueryClientProvider } from '@tanstack/react-query';
import { createAppQueryClient } from '@/lib/queryClient';
import AppRoutes from '../routes/app';
import { AuthProvider } from '@/auth';
import { TramiteProvider } from '../contexts/tramiteContext.jsx';
import { ColumnVisibilityProvider } from '../contexts/ColumnVisibilityContext.tsx';
import { PDFViewerProvider } from '../contexts/PDFViewerContext';
import ErrorBoundary from './ErrorBoundary';
import { ConfirmDialogProvider } from './ui/ConfirmDialog';

const queryClient = createAppQueryClient();

const MainApp = ({ }) => {

  return (
    <>
      <ErrorBoundary onError={(err, info) => Sentry.captureException(err, { contexts: { react: { componentStack: info.componentStack } } })}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ColumnVisibilityProvider>
              <TramiteProvider>
                <PDFViewerProvider>
                  <AppRoutes />
                </PDFViewerProvider>
              </TramiteProvider>
            </ColumnVisibilityProvider>
          </AuthProvider>
        </QueryClientProvider>
        <ConfirmDialogProvider />
        <Toaster position="top-right" />
      </ErrorBoundary>
    </>
  );
}

export default MainApp;
